import { render, staticRenderFns } from "./ProcessForm.vue?vue&type=template&id=631db5cf&scoped=true&"
import script from "./ProcessForm.vue?vue&type=script&lang=js&"
export * from "./ProcessForm.vue?vue&type=script&lang=js&"
import style0 from "./ProcessForm.vue?vue&type=style&index=0&id=631db5cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631db5cf",
  null
  
)

export default component.exports